import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import { getAuthenticatedUser } from "../../helpers/auth-session";
import { hasUnsavedChanges } from "../../helpers/unsaved-changes";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "../Common/AppOverlay";
import logo from "../../assets/images/piers-sidebar-logo.png";
import Footer from "./Footer";
import "./SwitchFirmLayout.scss";

export default function SwitchFirmLayout({ children }) {
  const navigate = useNavigate();
  const [logoutOpen, setLogoutOpen] = useState(false);
  const account = getAuthenticatedUser();
  return (
    <div className="switch-firm-layout">
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="reference-header-brand">
            <img src={logo} alt="" />
            <span><strong>PIERS</strong><small>Inspection Platform</small></span>
          </div>
          <div className="switch-firm-layout__account">
            <span className="switch-firm-layout__username">{account?.fullName || account?.name || "User"}</span>
            <button type="button" className="btn header-logout-button" onClick={() => setLogoutOpen(true)}>
              <FeatherIcon icon="log-out" /><span>Logout</span>
            </button>
          </div>
        </div>
      </header>
      <div className="switch-firm-layout__content">{children}</div>
      <Footer />
      <Modal centered isOpen={logoutOpen} toggle={() => setLogoutOpen(false)}>
        <ModalHeader toggle={() => setLogoutOpen(false)}>Confirm logout</ModalHeader>
        <ModalBody>{hasUnsavedChanges() ? "You have unsaved changes. Discard them and log out?" : "Are you sure you want to log out?"}</ModalBody>
        <ModalFooter>
          <Button color="light" onClick={() => setLogoutOpen(false)}>Stay</Button>
          <Button color="danger" onClick={() => navigate("/logout")}>{hasUnsavedChanges() ? "Discard changes and log out" : "Logout"}</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}
